import { Navigate } from 'react-router-dom';
import { useAuth } from "../../shared/auth/AuthContext";
import {environment} from "../../config/environment";

export function PrivateRoute({ children }) {
    const { authenticated, loading } = useAuth();

    if (environment.disableAuth) {
        return children;
    }

    if (loading) {
        return null; // ou spinner
    }


    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
